import {Component, Input} from "@angular/core";
import {UI_TEXTS} from "../../enums/e-texts";
import {VALUE_TYPE} from "../../enums/enums";
import {JP} from "../../helpers/jp";
import {FactoryService} from "../../services/factory.service";
import {localeUtils} from "../../helpers/locale-utils";
import {IAchievementStage} from "../../interfaces/achievement.definition";


@Component({
  selector: "nv-achievement-stages",
  templateUrl: "./nv-achievement-stages.component.html"
})


export class NvAchievementStagesComponent {
  UI_TEXTS = UI_TEXTS;
  VAL_TYPES = VALUE_TYPE;

  private _document: any;
  private _pointer: string;
  private _selected: IAchievementStage;

  @Input() set document(v: any) { this._document = v; }
  @Input() set pointer(v: string) { this._pointer = v; };

  get document() { return this._document; }
  get pointer() { return this._pointer; }
  get stages(): IAchievementStage[] { return JP.get(this.document, this.pointer); }
  get selected(): IAchievementStage { return this._selected; }


  constructor(private factoryService: FactoryService) {
  }


  getItemLabel(stage: IAchievementStage) {
    return localeUtils.findDescription(stage);
  }


  onItemSelected(stage: IAchievementStage) {
    this._selected = stage;
  }


  onAddClick() {
    this.factoryService.addAchievementStage(this.document, this.pointer);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-achievement-stages/nv-achievement-stages.component.ts